<template>
    <h1>Ahoi, {{ name }}</h1>
</template>

<script>
    export default {
        name: 'BannerPage',
        data(){
            return {
                name: ''
            }
        },
        components: {
        },
        mounted() {
            let dude = localStorage.getItem('facts')
            this.name=JSON.parse(localStorage.getItem('streetName'))
            if(!dude) {
                this.$router.push({name:'Login'})
            }
        }
    }
</script>

<style scoped>
 h1 {
    text-transform: uppercase;
    padding: 2px;
    text-align: center;
 }
</style>